import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { MediaPreview } from '../mediaPreview';

import { hideViewSourceModal } from '../../actions';

class ViewSourceModal extends Component {
    render () {
        const {show, hideViewSourceModal, mediaURL, title, mediaRowObject} = this.props;
        return (
            <Modal show={show} onHide={hideViewSourceModal}>
                <Modal.Header closeButton>
                    <Modal.Title> {title} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <MediaPreview mediaURL={mediaURL} mediaRowObject={mediaRowObject} noPreviewMessage='There is no preview avaliable for this filetype.\nTry downloading it and opening it using the link below.' />
                    <hr/>
                    <a href={mediaURL}>Download</a>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapDispatchToProps = {
    hideViewSourceModal
};

const mapStateToProps = state => ({
    scene: state.scene.current,
    show: state.ui.viewSource.show,
    mediaRowObject: state.ui.previewMedia.mediaRowObject
});

ViewSourceModal.propTypes = {
    show:                     PropTypes.bool.isRequired,
    hideViewSourceModal:      PropTypes.func.isRequired,
    mediaURL:                 PropTypes.string.isRequired,
    title:                    PropTypes.string.isRequired,
    mediaRowObject: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewSourceModal);



// WEBPACK FOOTER //
// ./src/components/viewSourceModal/ViewSourceModal.js